import { render, staticRenderFns } from "./PromotionDiscountOnTopPayment.vue?vue&type=template&id=714d683b&scoped=true&"
import script from "./PromotionDiscountOnTopPayment.vue?vue&type=script&lang=js&"
export * from "./PromotionDiscountOnTopPayment.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDiscountOnTopPayment.vue?vue&type=style&index=0&id=714d683b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714d683b",
  null
  
)

export default component.exports